import { translateFn } from '../../../../../../../../utils/translator.helper';
import { GeneralUpdateLocation } from '@nirvana/shared/dtos/types/policies/common';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../../ui/gzForm/formField/types/form-validator';
import { AddressValidator } from '../../../../../../../../ui/gzForm/validators/address.validator';
import { CustomizableValidator } from '../../../../../../../../ui/gzForm/validators/customizable.validator';

// get validators for server field
export const serverValidators = (): FormValidator<string>[] => {
  return [
    RequiredValidator(translateFn('Required field')),
    CustomizableValidator(value =>
      value.indexOf('upgrade.bitdefender.com') > -1
        ? { valid: false, error: translateFn('Invalid host address') }
        : { valid: true }
    ),
    AddressValidator(translateFn('Invalid host address'), true),
  ];
};

// validate duplicates
export function validateDuplicates(
  locationItem: GeneralUpdateLocation,
  locationsInGrid: GeneralUpdateLocation[]
): ValidationResult {
  const hasDuplicates = locationsInGrid.some(
    (locationInGrid: GeneralUpdateLocation) =>
      locationInGrid.useProxy === locationItem.useProxy && locationInGrid.server === locationItem.server
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
